import CookieBannerUtils from '../../utils/ols-core/CookieBannerUtils';
import GoogleAnalytics from '../../utils/GoogleAnalytics';

export const track = ({ eid, type, params } = {}) => {
  if (!CookieBannerUtils.isAccepted || !eid || !type) {
    return null;
  }

  window._trfq = window._trfq || [];
  const tcclEventName = 'pandc.ols.widget.' + eid;
  const gaEventName = eid.substr(0, eid.lastIndexOf('.'));

  GoogleAnalytics.logEvent(gaEventName, { app: 'ols', type });
  return window._trfq.push(['cmdLogEvent', type, tcclEventName, params || []]);
};
